import { Column, Img, Row } from "@react-email/components";
import { defaultStyles } from "./defaultStyles";

export const LogoSection = ({
  logoUrl,
  iconUrl,
  communityName,
}: {
  logoUrl: string | null;
  iconUrl: string | null;
  communityName: string;
}) => {
  if (logoUrl) {
    return (
      <Row style={defaultStyles.logoRow}>
        <Column align="center">
          <Img
            height={defaultStyles.image.height?.toString().replace("px", "")}
            width={defaultStyles.image.width?.toString().replace("px", "")}
            src={logoUrl}
            alt={communityName}
          />
        </Column>
      </Row>
    );
  }
  if (iconUrl) {
    return (
      <>
        <Row style={defaultStyles.logoRow}>
          <Column align="center">
            <Img
              width={defaultStyles.image.width?.toString().replace("px", "")}
              height={defaultStyles.image.height?.toString().replace("px", "")}
              src={iconUrl}
            />
          </Column>
        </Row>
        <Row style={defaultStyles.logoRow}>
          <Column align="center">
            <span style={defaultStyles.communityName}>{communityName}</span>
          </Column>
        </Row>
      </>
    );
  }
  return (
    <Row style={defaultStyles.logoRow}>
      <Column align="center">
        <span style={defaultStyles.communityName}>{communityName}</span>
      </Column>
    </Row>
  );
};
